import React from "react";
import ReactMarkdown from "react-markdown";

export default function Markdown({ children: markdown, ...props }) {
  return (
    <ReactMarkdown {...props}>{markdown}</ReactMarkdown>
  );
}
